import { FunctionComponent, useState } from 'react';
import ContainerScroll from '../AceternityUI/3D-cardEffect/containerScroll';
import SparklesCore from '../AceternityUI/3D-cardEffect/sparkle';
import styles from './Section2.module.css';


const Section2: FunctionComponent = () => {
	const [isMobile,] = useState(window.innerWidth <= 768);
	return (
		<><div className={styles.whyShouldYouTrustUsParent} >
			<div className={styles.textContainer}>
				<div className={styles.whyShouldYou}>Why should you trust us?</div>
				<div className={styles.neonLine}></div>
				<div >
				<SparklesCore />
				</div>
			</div>
		</div><ContainerScroll
  children={undefined}
  imageUrl={isMobile ? "/assets/trustmobile.svg" : "/assets/finalgrid.svg"}
/>
</>
	);

};

export default Section2;
